module.exports = __webpack_public_path__ + "img/eye_white.a82897f4.svg";